import { render } from "./loader-wrapper.vue?vue&type=template&id=6af496d6"
import script from "./loader-wrapper.vue?vue&type=script&lang=js"
export * from "./loader-wrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__